import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center', padding:'2rem', background:'var(--cream)' }}>
      <div>
        <div style={{ fontSize:'5rem', marginBottom:'1rem' }}>🏔️</div>
        <h1 style={{ fontFamily:'var(--font-serif)', fontSize:'5rem', fontWeight:'700', color:'#eee', lineHeight:1, marginBottom:0 }}>404</h1>
        <h2 style={{ fontFamily:'var(--font-serif)', fontSize:'1.8rem', color:'var(--dark)', marginBottom:'1rem' }}>Page Not Found</h2>
        <p style={{ color:'#777', marginBottom:'2rem', maxWidth:'400px' }}>Looks like this road doesn't go anywhere! Let us take you back on track.</p>
        <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap' }}>
          <Link to="/" className="btn-primary">🏠 Go Home</Link>
          <Link to="/contact" className="btn-green">📞 Contact Us</Link>
        </div>
      </div>
    </div>
  );
}
